import React from "react"
import { Text } from "@chakra-ui/react"

const ProductGridEmpty: React.FC = () => <Text fontWeight="bold">No results found.</Text>

export default ProductGridEmpty
